/**
 * Classe que testa os tipo Tag
 * @author: Adalto Junior
 * DATE: 21/08/2014
 */


Monet.Format = Monet.Format || {};
Monet.Format.TAG = (function () {

    function TAG(value) {

        Monet.Format.ARRAY_BASED.apply(this, arguments);

        this.value = value;

        this.toGrid = function () {

            this.formatToString();

            return this;
        };

    }

    return TAG;

}());
